import getConfig from '../config/env'

class Settings {
  constructor(config) {
    this.config = config
  }

  getConfig() {
    return this.config
  }

  getCoreUrl(url, service) {
    return `${this.config[service]}/${url}`
  }
  getScheduleUrl(url, service) {
    return `${this.config[service]}/${url}`
  }
}

export default new Settings(getConfig(process.env.NODE_ENV).config);
